import { required, requiredIf } from 'vuelidate/lib/validators';
import { documentIdCericRegex, emailRegex } from '@/assets/validators/regexValidator';

function isEndStationValidationPassed() {
  if (this.cericProposalParameters.infrastructure === 'synchrotron') {
    return !this.cericProposalParameters.end_station;
  }
  return false;
}

const numberValidation = (val) => (val ? Number.isInteger(Number(val)) : true);

const cericProposalValidator = {
  cericProposalParameters: {
    call_id: { required },
    document_id: {
      required,
      lengthValidation(val) {
        if (val) {
          return (val.length === 8 && numberValidation(val)) || documentIdCericRegex.test(val);
        }
        return true;
      },
    },
    attachments: {
      required,
      lengthValidation(val) {
        if (val) {
          return val.length > 0;
        }
        return true;
      },
    },
    title: { required },
    requested_hours: {
      required,
      numberValidation,
      rangeValidation(val) {
        if (val) {
          return val >= 0;
        }
        return true;
      },
    },
    shifts: {
      required,
      numberValidation,
      rangeValidation(val) {
        if (val) {
          return val >= 0 && val < 20;
        }
        return true;
      },
    },
    main_author_name: { required },
    main_author_email: {
      required,
      regexValidation(val) {
        if (val) {
          return emailRegex.regex.test(val);
        }
        return true;
      },
    },
    beamlines: { requiredIf: requiredIf(isEndStationValidationPassed) },
    end_station: { requiredIf: requiredIf(isEndStationValidationPassed) },
  },
};

export { cericProposalValidator };
